import { render, staticRenderFns } from "./CollectionReport.vue?vue&type=template&id=0d0732f3&scoped=true"
import script from "./CollectionReport.vue?vue&type=script&lang=js"
export * from "./CollectionReport.vue?vue&type=script&lang=js"
import style0 from "./CollectionReport.vue?vue&type=style&index=0&id=0d0732f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0732f3",
  null
  
)

export default component.exports